<template>
  <div class="config-panel">
    <div class="config-panel__header">
      <h2>{{ title }}</h2>
    </div>
    <router-view />
    <div class="banner-headline">
      <span>Banner:</span>
    </div>
    <div class="banner-buttons">
      <el-radio-group v-model="banner" @change="changeBanner">
        <el-radio-button
          :label="'https://treatec.ams3.digitaloceanspaces.com/ibis/generator/accor-allsafe-banner-de.jpg'"
        >
          <p>ALLSAFE banner - DE</p>
          <img
            style="width:460px"
            src="https://treatec.ams3.digitaloceanspaces.com/ibis/generator/accor-allsafe-banner-de.jpg"
          />
        </el-radio-button>
        <el-radio-button
          :label="'https://treatec.ams3.digitaloceanspaces.com/ibis/generator/accor-allsafe-banner-en.jpg'"
        >
          <p>ALLSAFE banner - EN</p>
          <img
            style="width:460px"
            src="https://treatec.ams3.digitaloceanspaces.com/ibis/generator/accor-allsafe-banner-en.jpg"
          />
        </el-radio-button>
        <el-radio-button
          :label="'https://treatec.ams3.digitaloceanspaces.com/ibis/generator/accor-allsafe-banner-fr.jpg'"
        >
          <p>ALLSAFE banner - FR</p>
          <img
            style="width:460px"
            src="https://treatec.ams3.digitaloceanspaces.com/ibis/generator/accor-allsafe-banner-fr.jpg"
          />
        </el-radio-button>
      </el-radio-group>
    </div>
  </div>
</template>

<script>
import fields from "../db/main-fields";

export default {
  name: "",

  data() {
    return {
      banner:
        "https://treatec.ams3.digitaloceanspaces.com/ibis/generator/accor-allsafe-banner-de.jpg"
    };
  },

  computed: {
    title() {
      if (this.$route.name) {
        return this.$t(`navigation.pageTitle.${this.$route.name}`);
      }
    }
  },

  methods: {
    changeBanner(banner) {
      fields.banner.value = banner;
    }
  }
};
</script>

<style lang="scss">
@import "../assets/scss/variables.scss";

.config-panel {
  padding: 40px;
  overflow-y: auto;
  h2 {
    line-height: 0;
  }
  &__header {
    margin-bottom: 40px;
  }
}
.banner-headline {
  margin-top: 10px;
  margin-bottom: 20px;

  span {
    font-size: 14px;
    color: #606266;
  }
}
.banner-buttons {
  text-align: center;

  label {
    margin: 10px 0;

    span {
      padding: 4px;
      border: 2px solid #fff;
      border-radius: 4px;
      background: #fff;
      transition: all 0.5s ease-in;

      p {
        font-size: 12px;
        color: #606266 !important;
        margin: 6px 0;
      }

      img {
        transition: all 0.5s ease-in;
        opacity: 0.5;
      }
    }
  }

  .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    border: 2px solid #606266;
    border-radius: 4px;
    background-color: #fff;
    -webkit-box-shadow: -1px 0 0 0 #606266;
    box-shadow: -1px 0 0 0 #606266;
    transition: all 0.5s ease-in;

    img {
      opacity: 1;
    }
  }
}
</style>
